const e = {
  add: "Toevoegen",
  cancel: "Annuleren",
  clear: "Wissen",
  confirm: "Bevestigen",
  delete: "Verwijderen",
  redo: "Opnieuw uitvoeren",
  save: "Opslaan",
  saveAs: "Opslaan als",
  undo: "Ongedaan maken"
}, n = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, a = {
  cancel: "Annuleren",
  confirm: "Bevestigen",
  datePlaceholder: "Datum selecteren",
  datetimePlaceholder: "Datum en tijd selecteren",
  endDatePlaceholder: "Einddatum",
  endDatetimePlaceholder: "Einddatum en tijd",
  endMonthPlaceholder: "Eind maand",
  monthPlaceholder: "Selecteer Maand",
  now: "Nu",
  quarterPlaceholder: "Selecteer kwartaal",
  selectDate: "Datum selecteren",
  selectTime: "Tijd selecteren",
  startDatePlaceholder: "Begindatum",
  startDatetimePlaceholder: "Begindatum en tijd",
  startMonthPlaceholder: "Start maand",
  today: "Vandaag",
  weekPlaceholder: "Selecteer Week",
  yearPlaceholder: "Selecteer Jaar",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, t = {
  placeholder: "Maak een keuze"
}, o = {
  clear: "Wissen",
  negativeText: "Annuleren",
  now: "Nu",
  placeholder: "Tijd selecteren",
  positiveText: "Oké"
}, l = {
  placeholder: "Invoeren"
}, r = {
  placeholder: "Invoeren"
}, d = {
  placeholder: "Begin met typen..."
}, i = {
  allRows: "Alle rijen",
  default: "Standaard",
  deleteLayoutDescription: "Weet u zeker dat u deze lay-out wilt verwijderen?",
  discardChanges: "Wijzigingen negeren",
  discardLayoutChanges: "Wijzigingen in lay-out negeren",
  enterLayoutName: "Voer lay-outnaam in",
  enterRowNumber: "Voer het aantal rijen in",
  fieldsSelected: "Geselecteerde velden",
  freezeColumnDescription: "Zet de kolom aan de linkerkant vast",
  freezeUptoColumn: "Bevriezen tot kolom",
  frozen: "Bevroren",
  layoutName: "Lay-outnaam",
  manageColumns: "Kolommen beheren",
  none: "Geen",
  reorderRows: "Rijen Opnieuw Ordenen",
  rowsSelected: "rijen geselecteerd",
  saveLayoutAs: "Lay-out opslaan als",
  saveLayoutNew: "Nieuwe lay-out opslaan",
  search: "Zoeken",
  searchColumnsPlaceholder: "Kolommen zoeken",
  searchFieldsPlaceholder: "Velden zoeken",
  selectAll: "Alles selecteren",
  setTableHeight: "Stel de tafelhoogte in",
  unfreeze: "Ontdooien",
  unsavedChanges: "U heeft niet opgeslagen wijzigingen",
  unsavedChangesDescription: "Er kunnen een of meerdere niet-opgeslagen wijzigingen zijn. Wilt u ze bewaren?"
}, s = {
  at: "bij",
  colorAlreadyUsed: "Kies een andere tint of gebruik bestaande",
  colorNamePlaceholder: "Voer een naam in",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Selecteer een andere kleurnaam",
  noColorsAdded: "U hebt geen kleuren in dit gedeelte."
}, c = {
  searchPlaceholder: "Zoeken"
}, u = {
  invalidPastedData: "Ongeldig geplakte gegevens"
}, p = {
  of: "van",
  page: "Pagina",
  rowsPerPage: "Rijen per pagina"
}, g = {
  failedToUpload: "Uploaden mislukt",
  retry: "Opnieuw proberen",
  clickToUpload: "click om te Upload",
  orDragAndDrop: "Van Drag en neerzetten",
  supportedFileTypes: "Ondersteunde File :"
}, m = {
  global: e,
  Progress: n,
  DatePicker: a,
  Select: t,
  TimePicker: o,
  Input: l,
  InputNumber: r,
  InputTag: d,
  HLDataTable: i,
  ColorPicker: s,
  InputPhone: c,
  InputOtp: u,
  Pagination: p,
  Upload: g
};
export {
  s as ColorPicker,
  a as DatePicker,
  i as HLDataTable,
  l as Input,
  r as InputNumber,
  u as InputOtp,
  c as InputPhone,
  d as InputTag,
  p as Pagination,
  n as Progress,
  t as Select,
  o as TimePicker,
  g as Upload,
  m as default,
  e as global
};
